import { Airhelp, AirhelpPlus, AirhelpPlusItalics, APRA } from "@airhelp/react";

export const logos = {
  AirhelpLogo: Airhelp,
  AirhelpPlusLogo: AirhelpPlus,
  AirhelpPlusItalicsLogo: AirhelpPlusItalics,
  APRA,
};
